module.exports = __webpack_public_path__ + "img/11.8e283606.png";